module.exports = __webpack_public_path__ + "static/media/default_avi.5fdbfa63.svg";